(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-catalog-header]').forEach(header => {
      if (header.dataset.catalogReady) return;
      header.dataset.catalogReady = 'true';
      const mobile = window.matchMedia('(max-width: 1280px)');
      const toggle = header.querySelector('[data-catalog-toggle]');
      const items = [...header.querySelectorAll('[data-catalog-item]')];
      const setItem = (item, open) => {
        item.classList.toggle('is-open', open);
        item.querySelector('[data-catalog-submenu-toggle]')?.setAttribute('aria-expanded', String(open));
      };
      const closeItems = () => items.forEach(item => setItem(item, false));
      const setNavigation = open => {
        header.classList.toggle('is-open', open);
        toggle?.setAttribute('aria-expanded', String(open));
        if (toggle) toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
        if (!open) closeItems();
      };
      const measure = () => header.style.setProperty('--catalog-header-height', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      measure();
      new ResizeObserver(measure).observe(header);
      let measureFrame;
      const queueMeasure = () => {
        if (!header.classList.contains('is-open') && !header.querySelector('.catalog-item.is-open')) return;
        cancelAnimationFrame(measureFrame);
        measureFrame = requestAnimationFrame(measure);
      };
      window.addEventListener('scroll', queueMeasure, { passive: true });
      window.addEventListener('resize', queueMeasure, { passive: true });
      toggle?.addEventListener('click', () => { measure(); setNavigation(!header.classList.contains('is-open')); });
      items.forEach(item => {
        item.querySelector('[data-catalog-submenu-toggle]')?.addEventListener('click', () => {
          const open = !item.classList.contains('is-open');
          closeItems();
          setItem(item, open);
        });
        item.addEventListener('mouseenter', () => {
          if (mobile.matches || !matchMedia('(hover: hover)').matches) return;
          measure();
          closeItems();
          setItem(item, true);
        });
        item.addEventListener('mouseleave', () => {
          if (!mobile.matches && !item.contains(document.activeElement)) setItem(item, false);
        });
      });
      header.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!header.contains(document.activeElement)) { setNavigation(false); return; }
          if (!mobile.matches) items.forEach(item => { if (!item.contains(document.activeElement)) setItem(item, false); });
        });
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const item = event.target.closest('[data-catalog-item].is-open');
        if (item) { setItem(item, false); item.querySelector('[data-catalog-submenu-toggle]')?.focus(); }
        else if (header.classList.contains('is-open')) { setNavigation(false); toggle?.focus(); }
        event.preventDefault();
      });
      document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) setNavigation(false); });
      mobile.addEventListener('change', () => setNavigation(false));
    });
    scope.querySelectorAll('[data-catalog-sort]').forEach(select => {
      if (select.dataset.catalogReady) return;
      select.dataset.catalogReady = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      });
    });
    scope.querySelectorAll('[data-catalog-page-size]').forEach(link => {
      const url = new URL(window.location.href);
      url.searchParams.set('view', link.dataset.catalogPageSize);
      url.searchParams.delete('page');
      link.href = url.pathname + url.search;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
